import { render, staticRenderFns } from "./drag.vue?vue&type=template&id=5098200c"
import script from "./drag.vue?vue&type=script&lang=js"
export * from "./drag.vue?vue&type=script&lang=js"
import style0 from "./drag.vue?vue&type=style&index=0&id=5098200c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports